import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  setNumberTranferType,
  setNumberTransferDetails,
} from "../../../Redux/actions/checkoutAction";
import ajaxServices from "../../../utils/ajaxServices";

import {
  hideSpinner,
  imagePrefix,
  showSpinner,
  urlPrefix,
} from "../../../utils/helperServices";
import { useDispatch, useRouter } from "../../atoms/DependencyHelper";
import UpgradeComponent from "../upgradeModal/UpgradeModal";
import { NumberTransferTypes } from "../../../config/constants";
import * as Analytics from "../../../services/analyticsUtag";

const GeneralError = ({ navigate, showGeneralError }) => {
  const sendAnalitycsLink = (additionalInfo) => {
    Analytics.link({
      ...Analytics.getUtagData([
        "page_event",
        "page_name",
        "page_channel",
        "page_master_tab",
        "page_channel",
        "page_master_tab",
        "visitor_login_status",
        "visitor_customer_id",
        "visitor_id_hash",
        "visitor_msisdn_hash",
        "visitor_subscription_type",
      ]),
      link_type: "o",
      ...additionalInfo,
    });
  };

  const [errorDetails, setErrorDetails] = useState({
    title: "",
    analyticTitle: "",
    description: "",
  });

  const dispatch = useDispatch();

  const next = () => {
    sendAnalitycsLink({
      link_name: "checkout: number transfer: new number",
      link_type: "o",
    });
    dispatch(setNumberTransferDetails({}));
    dispatch(setNumberTranferType(NumberTransferTypes.NEW_NUMBER));
    navigate("review");
  };

  const router = useRouter();

  useEffect(() => {
    showSpinner();
    ajaxServices
      .httpGet("drupalBaseUrl", "", "api", "errorResultDetails", [
        "number_transfer_error",
      ])
      .then((response) => {
        setErrorDetails({
          title: response[0].resultTitle,
          analyticTitle: response[0].analyticTitle,
          description: response[0].resultHTML,
          primaryButtonText: response[0].primaryCTAText,
          secondaryButtonText: response[0].secondaryCTAText,
          ...(response[0] || {}),
        });
      })
      .catch(() => {
        setErrorDetails({
          title: "We’ve encountered a technical issue",
          analyticTitle: "shopping: upgrade: eligibility: enter otp",
          description:
            "Unfortunately, we cannot validate your prepaid number right now.<br /><br />If you would like to continue checking out now, you can choose to have a new number assigned to your contract. Otherwise you can exit checkout and let one of our consultants contact you to transfer your number and complete your application telephonically.",
          primaryButtonText: "Continue & Get a new number",
        });
      })
      .finally(() => hideSpinner());
  }, []);
  
  if (!errorDetails.title) {
    return null;
  }

  return (
    <UpgradeComponent
      showModal={true}
      toggleModal={() => {
        showGeneralError((currentValue) => !currentValue);
        sendAnalitycsLink({
          link_name: "checkout: number transfer: dismiss",
          link_type: "o",
        });
      }}
      displayData={{
        iconUrl: `${imagePrefix}/assets/images/error-warning-red.svg`,
        title: errorDetails.title,
        analyticTitle: errorDetails.analyticTitle,
        description: errorDetails.description,
        primaryButtonText: errorDetails.primaryButtonText,
        secondaryButtonStyle: "flat black",
        onClickHandlerPrimary: next,
        secondaryButtonText: errorDetails.secondaryCTAText,
        onClickHandlerSecondary: () => {
          sendAnalitycsLink({
            link_name: "checkout: number transfer: call me back",
            link_type: "o",
          });
          router.push(
            `${urlPrefix}/${errorDetails.secondaryCTAURL}?bucket=${errorDetails.leadType}`
          );
        },
      }}
    />
  );
};

GeneralError.propTypes = {
  navigate: PropTypes.func,
  showGeneralError: PropTypes.func,
};

export default GeneralError;
